//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import portal from '~/net/portal'
import config from '~/config'
import { isNumber } from '~/constant/validform'
import { searchCodes } from '~/constant/SearchCodes'
import { cooperationMode } from '~/constant/types'
const formatList = ['jpg', 'png', 'pdf', '.doc', 'docx', 'zip']
export default {
    name: 'Good',
    head() {
        return {
            title: '商品详情',
            meta: [{ hid: 'keywords', name: 'keywords', content: this.good.name }, { hid: 'description', name: 'description', content: this.good.summary }]
        }
    },
    data() {
        return {
            businessBrowserUrl: config.businessBrowserUrl,
            formatList,
            reportData: {
                firstType: '',
                secondType: '',
                description: '',
                goodsReportFileDtos: []
            },
            uploadText: {
                upText: '上传附件',
                tipText: ''
            },
            secondReportType: [],
            rateList: [],
            wechatUrl: '',
            good: {},
            loginVisible: false
        }
    },
    async asyncData({ query, error, req }) {
        const [resp1, resp2, resp3] = await Promise.all([
            portal.getGoodsInfo({
                query: {
                    id: query.id,
                    isPortal: true
                },
                client: req
            }),
            portal.getAllFirstTypes({
                client: req
            }),
            portal.getShopDetail({
                client: req
            })
        ])
        let data1
        if (resp1.code == '0000') {
            data1 = resp1.data
        } else {
            error({ statusCode: resp1.statusCode, messsage: resp1.message })
        }
        const data2 = resp2.data
        const data3 = resp3.data
        return {
            good: data1,
            topImage: data1.hasOwnProperty('goodsFileDtos') ? data1.goodsFileDtos[0] : {},
            firstReportType: data2,
            shop: data3
        }
    },
    mounted() {
        portal
            .getShopDetailsById({
                query: { shopId: this.good.shopId }
            })
            .then(({ code, data }) => {
                if (code !== '0000') {
                    return
                }
                this.wechatUrl = data.wechatUrl
            })
    },
    validate({ query }) {
        return !!query.id
    },
    watchQuery: ['id'],
    computed: {
        ...mapState(['user', 'identities']),
        routes() {
            return [{ name: '首页', path: '/' }, { name: '举报中心' }]
        }
    },
    methods: {
        handleSuccess(res) {
            this.reportData.goodsReportFileDtos = [
                {
                    name: res.data.name,
                    type: '0',
                    url: res.data.url
                }
            ]
            this.uploadText.upText = '重新上传'
            this.uploadText.tipText = '文件上传成功,请稍后查看导入结果'
        },
        handleProgress() {
            this.uploadText.tipText = '正在上传，请稍后...'
        },
        handleError() {
            this.reportData.goodsReportFileDtos = []
            this.uploadText.tipText = '上传失败，请稍后重试'
        },
        handleExceeded() {
            this.$Message.error('文件最大为5M，请重新选择附件')
        },
        async selectFirstTypeAsync() {
            const { code, data } = await portal.getAllSecondTypesById({
                query: {
                    id: JSON.parse(this.reportData.firstType).id
                }
            })
            if (code === '0000') {
                this.secondReportType = data || []
            }
        },
        validate() {
            if (!(this.reportData.firstType && this.reportData.secondType)) {
                this.$Message.warning('请选择举报类型')
            } else if (!this.reportData.description.trim()) {
                this.$Message.warning('请填写举报描述')
            } else {
                this.reportAsync()
            }
        },
        async reportAsync() {
            const firstType = JSON.parse(this.reportData.firstType)
            const secondType = JSON.parse(this.reportData.secondType)
            const body = {
                userId: this.good.userId,
                shopId: this.good.shopId,
                shopName: this.good.shopInfoDtos[0].name,
                goodsId: this.good.id,
                goodsName: this.good.name,
                firstType: firstType.id,
                firstTypeName: firstType.name,
                secondType: secondType.id,
                secondTypeName: secondType.name,
                goodsReportFileDtos: this.reportData.goodsReportFileDtos,
                description: this.reportData.description
            }
            const { code } = await portal.applyGoodsReport({
                body
            })
            console.log(code)
            if (code === '0000') {
                this.$Message.success('举报成功')
                this.goBack()
            }
        },
        goBack() {
            this.$router.go(-1)
        },
        getTransactionMode() {
            let status = ''
            if (this.good.transactionMode == '02') {
                if (this.good.achievementLicenseType == '00') {
                    status = '独占许可'
                } else if (this.good.achievementLicenseType == '01') {
                    status = '普通许可'
                } else {
                    status = '排他许可'
                }
            } else {
                const temp = cooperationMode.find(_ => _.type == this.good.transactionMode)
                status = (temp && temp.text) || ''
            }

            return status
        }
    }
}
